export const Mission = () => {
    return (
        <div className="container py-5">
            <div className="row">
                {/* Mission Section */}
                <div className="col-md-6">
                    <div className="card shadow-sm border-0">
                        <div className="card-header bg-white border-bottom-0">
                            <h4 className="fw-bold">OUR MISSION</h4>
                            <hr className="border-danger w-25" />
                        </div>
                        <div className="card-body">
                            <p className="lead text-muted">
                                The biggest advantage of the OA model is that it provides free, full-text articles in PDF and other formats for experts and
                                the public without registration, eliminating the obstacle that traditional journals possess and usually delaying the speed
                                of scientific research dissemination. The open access model has proven to be a true approach that maximizes value for
                                readers, authors, libraries, colleges, universities, and society.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Vision Section */}
                <div className="col-md-6">
                    <div className="card shadow-sm border-0">
                        <div className="card-header bg-white border-bottom-0">
                            <h4 className="fw-bold">OUR VISION</h4>
                            <hr className="border-danger w-25" />
                        </div>
                        <div className="card-body">
                            <p className="lead text-muted">
                                The role of academic journals is to exhibit the scientific levels of a country, university, center, department, and even a
                                scientist, while also building an important bridge for communication between researchers and the public. The significance of
                                publishing scientific and non-scientific articles lies not only in disseminating and communicating innovative achievements
                                and academic perspectives but also in promoting research applications, recognizing priorities, copyrights, and evaluating
                                academic performance.
                            </p>
                            <p className="text-warning fw-semibold">
                                The maximization of personal benefits refers to the pursuit of the maximum personal benefits in a well-considered optimal
                                manner without violation of laws, ethical rules, and the benefits of others.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
